import React from 'react';
import styled from '../index.module.scss';
import { useQuestionStore, useQuestionDispatch } from '../../QuestionProvider';
import { useGlobal } from '@/utils/useGlobal';
import Button from '@/components/UI/Button';

interface ExamFooterProps {
    submit: () => void;
    finshed: () => void;
    answer: string;
}

const ExamFooter: React.FC<ExamFooterProps> = ({ submit, finshed, answer }) => {
    const { useLang, isMobile } = useGlobal();
    const { index, question, loading } = useQuestionStore();
    const { defAnswer } = question[index];
    const dispatch = useQuestionDispatch();
    const { t } = useLang('appreciationday');

    const handleNext = (index: number) => {
        dispatch({
            type: 'changeIndex',
            payload: index,
        });
    };

    const handleSubmit = () => {
        if (!defAnswer) return submit();
        if (index === question.length - 1) return finshed();
        handleNext(index + 1);
    };

    return (
        <div className={styled.exam_footer}>
            <Button className="back" disabled={index <= 0} aria-label={'back'} onClick={() => handleNext(index - 1)}>
                {t('question.prev')}
            </Button>
            <Button className="confrim" aria-label={t('question.prev')} disabled={!answer && !defAnswer} onClick={handleSubmit} loading={loading}>
                {!defAnswer ? t('question.submit') : t('question.next')}
            </Button>
        </div>
    );
};

export default ExamFooter;
